
import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";

import * as api from "../../constant/NewAPI";
import Utils from "../../constant/Utils";
import Swal from "sweetalert2";

const Batches = () => {

    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [instituteId, setInstituteId] = useState(null);
    const [cbinstituteId, setCbInstituteId] = useState(null);
    const [programId, setProgramId] = useState(null);
    const [cbprogramId, setCbProgramId] = useState(null);
    const [batchId, setBatchId] = useState(null);
    const [batchCoachId, setBatchCoachId] = useState(null);
    const [instituteList, setInstituteList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [studList, setStudList] = useState([]);
    const [programList, setProgramList] = useState([]);
    const [sportList, setSportList] = useState([]);
    const [batchDetails, setBatchDetails] = useState([]);
    const [coachDetails, setCoachDetails] = useState([]);
    const [sprtInsDetails, setSprtInsDetails] = useState([]);
    const [batchStudDetails, setBatchStudDetails] = useState([]);
    const [addBatchList, setAddBatchList] = useState([]);
    const [addStudentsList, setAddStudentsList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [batchName, setBatchName] = useState("");
    const [batchStatus, setBatchStatus] = useState("");
    const [newBatchName, setNewBatchName] = useState("");
    const [coachName, setCoachName] = useState("");
    const [cbSportId, setCbSportId] = useState("");
    const [cbCoachId, setCbCoachId] = useState("");
    const [sportId, setSportId] = useState("");
    const [sportName, setSportName] = useState("");
    const [addInstituteId, setAddInstituteId] = useState("");
    const [addCoachId, setAddCoachId] = useState("");
    const [addProgramId, setAddProgramId] = useState("");
    const [addBatchId, setAddBatchId] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [classId, setClassId] = useState('');
    const [sectionId, setSectionId] = useState('');
    const [searchAddQuery, setSearchAddQuery] = useState("");
    const [showList, setShowList] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const cbformRef = useRef(null);
    const adStudformRef = useRef(null);
    const updtStudformRef = useRef(null);
    const checkboxRefs = useRef([]);
    const addcheckboxRefs = useRef([]);

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');


    useEffect(() => {
        insts();
        progs();
        sprts();
    }, []);

    function insts() {
        const getInstList = api.InstituteDd + '/' + roleId;//"?userId=" + userId + '&roleId=' + roleId;
        setIsLoading(true);
        setTimeout(() => {
            fetch(getInstList, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                }
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == true) {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        setIsLoading(false)
                        Swal.fire(result.message)
                    }
                    else {
                        setInstituteList(result.data)
                        setIsLoading(false)
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false);
                })
        }, 1000);
    }

    function getClass(instid) {
        const getclslist = api.GetClass + '/' + instid // "?insId=" + instid;
        fetch(getclslist, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((clsResponse) => clsResponse.json())
            .then((clsResult) => {
                if (clsResult.code == 401) {
                    Utils.logoutUser();
                }
                if (clsResult.data != null) {
                    setClassList(clsResult.data)
                }

            })
            .catch((error) => {
                console.log("Failed to fetch class list", error);
            })
    }

    function getSection(clsid) {
        const getseclist = api.GetSection + '/' + clsid + '/' + addInstituteId // "?insId=" + instituteId + "&classId=" + clsid;
        fetch(getseclist, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((secResponse) => secResponse.json())
            .then((secResult) => {
                if (secResult.code == 401) {
                    Utils.logoutUser();
                }
                if (secResult.data != null) {
                    setSectionList(secResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch section list", error)
            })
    }

    function progs() {
        const progList = api.ProgramList;
        fetch(progList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == true) {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                }
                else {
                    setProgramList(result.data)
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setIsLoading(false);
            })
    }

    function sprts() {
        const sportsList = api.SportList;
        fetch(sportsList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((sresult) => {
                if (sresult.error == true) {
                    if (sresult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(sresult.message)
                }
                setSportList(sresult.data)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setIsLoading(false);
            })
    }

    function addStuds() {
        // formData.append('student', element)
        addcheckboxRefs.current.forEach((checkbox) => {
            if (checkbox) checkbox.checked = false;
        })
        setAddBatchId("");
        setAddInstituteId("")
        setAddProgramId("")
        setClassId("")
        setSectionId("")
        setAddStudentsList([])
        setShowList(false)
    }

    function listBatches(insId) {
        setIsLoading(true)
        setTimeout(() => {
            const getBatches = api.BatchList + '/' + roleId + '/' + insId;//"?userId=" + userId + "&roleId=" + roleId + "&institutionName=" + insId
            fetch(getBatches, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                }
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == true) {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire(result.message)
                        setIsLoading(false)
                    }
                    else {
                        setBatchList(result.data);
                        setIsLoading(false);
                        setShowTable(true);
                    }
                })

                .catch(error => {
                    console.error('Error fetching data:', error);
                    setIsLoading(false)
                })
        }, 1000);
    }

    function addStudBatch(e) {
        e.preventDefault();
        if (!adStudformRef.current.checkValidity()) {
            adStudformRef.current.reportValidity();
        } else {
            // alert("Success,Students successfully added to the batch.");
            const selectedStudents = addcheckboxRefs.current
                .filter(checkbox => checkbox.checked)
                .map(checkbox => checkbox.value);
            setIsLoading(true)
            setTimeout(() => {
                const formData = new FormData();
                selectedStudents.forEach(element => {
                    formData.append('student', element)
                    formData.append('batch', addBatchId)
                    formData.append('institute', addInstituteId)
                    formData.append('program', addProgramId)

                    const addStudent = api.AddStudentToBatch;
                    fetch(addStudent, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((studentResponse) => studentResponse.json())
                        .then((studentResult) => {
                            if (studentResult.error == false) {
                                setIsLoading(false);
                                Swal.fire({
                                    title: 'Success',
                                    text: studentResult.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (studentResult.code == 401) {
                                    Utils.logoutUser();
                                }
                                setIsLoading(false);
                                Swal.fire({
                                    title: 'Error',
                                    text: studentResult.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                })
            }, 1000)
        }
    }

    const filteredData = batchList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const filteredStudents = studList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchQuery.toLowerCase()));
    });

    const filteredAddStudents = addStudentsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchAddQuery.toLowerCase()));
    });


    const detailsRender = (rowData) => {
        return (
            <Link to="#" data-bs-toggle="modal" data-bs-target="#student-list" onClick={() => viewDetails(rowData)}>
                <i className="feather feather-eye"></i>View Details
            </Link>
        );
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" data-bs-toggle="modal" data-bs-target="#edit-batch" onClick={() => editBatch(rowData)}>
                <i className="feather-edit" />
                Edit
            </Link>
        );
    };

    const archiveRow = (rowData) => {
        if (rowData.batchStatus == 1) {
            return (
                <Link to="#" data-bs-toggle="" data-bs-target="" onClick={() => archiveBatch(rowData)}>
                    <i className="feather-archive" />
                    Archive
                </Link>
            );
        }
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchRender = (rowData) => {
        return <span>{rowData.batchName}</span>;
    };

    const instituteRender = (rowData) => {
        return <span>{rowData.institutionName}</span>;
    };

    const coachRender = (rowData) => {
        return <span>{rowData.CoachName}</span>;
    };

    const sportRender = (rowData) => {
        return <span>{rowData.SportName}</span>;
    };

    const programRender = (rowData) => {
        return <span>{rowData.ProgramName}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.batchStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    function viewDetails(selectedBatch) {
        const batchId = selectedBatch.batchId;
        const batchName = selectedBatch.batchName;
        setBatchName(batchName);
        setIsLoading(true)
        setTimeout(() => {
            const studList = api.BatchStudentList + '/' + batchId + '/' + instituteId;//"/?batchId=" + batchId + "&instId=" + instituteId;
            fetch(studList, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == true) {
                        setIsLoading(false)
                        Swal.fire(result.message)
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                    }
                    else {
                        setBatchStudDetails(result.data);
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    console.log("Error fetching data: ", error);
                })
        }, 1000);
    }

    function editBatch(batch) {
        // console.log(JSON.stringify(batch))
        const btchId = batch.batchId;
        const cochId = batch.batchCoachId;
        setBatchId(btchId)
        setProgramId(batch.batchProgramId);
        setBatchName(batch.batchName);
        setSportId(batch.batchSportId)
        setBatchCoachId(batch.batchCoachId);
        setBatchStatus(batch.batchStatus);
        setCoachName(batch.CoachName);
        // setSportId(batch.batchSportId)
        setSportName(batch.SportName);

        const batchdtls = api.BatchDetails + '/' + btchId + '/' + instituteId;//"?batchId=" + btchId + "&instId=" + instituteId;
        fetch(batchdtls, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == true) {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                }
                else {
                    setBatchDetails(result.data);
                    coachList(instituteId);
                    sportsList(cochId, instituteId);
                    studentList(btchId);
                }
            })
            .catch((error) => {
                console.log("Error fetching Batch details: ", error);
            })
    }

    function coachList(insid) {
        const coachLst = api.CoachList + '/' + insid; // "?institutionId=" + insid;
        fetch(coachLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((coresponse) => coresponse.json())
            .then((coresult) => {
                if (coresult.error == true) {
                    Swal.fire(coresult.message)
                    if (coresult.code == 401) {
                        Utils.logoutUser();
                    }
                }
                else {
                    setCoachDetails(coresult.data)
                }
            })
            .catch((error) => {
                console.log("Error fetching Coach details: ", error)
            })
    }

    function studentList(btchId) {
        const batchStudListMrkd = api.BatchStudListMarked + '/' + btchId + '/' + instituteId; //"?institutionId=" + instituteId + "&batchId=" + batchId;
        // console.log(batchStudListMrkd)
        fetch(batchStudListMrkd, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((studresponse) => studresponse.json())
            .then((studresult) => {
                if (studresult.error == true || studresult.code != 200) {
                    Swal.fire(studresult.message)
                    if (studresult.code == 401) {
                        Utils.logoutUser();
                    }
                }
                else {
                    setStudList(studresult.data)
                }
            })
            .catch((error) => {
                console.log("Error fetching student list", error);
            })
    }

    function sportsList(cochId, insId) {
        const dtlsSprtIns = api.SportDetailsInst + '/' + cochId + '/' + insId; //+ "?insId=" + instituteId + "&coach=" + batchCoachId;
        fetch(dtlsSprtIns, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((cochresponse) => cochresponse.json())
            .then((cochresult) => {
                if (cochresult.error == true) {
                    Swal.fire(cochresult.message)
                    if (cochresult.code == 401) {
                        Utils.logoutUser();
                    }
                }
                else {
                    setSprtInsDetails(cochresult.data)
                }
            })
            .catch((error) => {
                console.log("Error fetching sport Institute Details", error)
            })
    }

    function studentsList(secId) {
        // const getStuds = api.BatchStudents + '/' + inst; //?insId=" + inst;
        const getStuds = api.GetClassStudents + '/' + addInstituteId + '/' + classId + '/' + secId;
        fetch(getStuds, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((studsResponse) => studsResponse.json())
            .then((studsResult) => {
                // console.log(studsResult.data);

                if (studsResult.error == true) {
                    if (studsResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(studsResult.message)
                }
                else {
                    setAddStudentsList(studsResult.data)
                    setShowList(true);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the list of students to add students", error);
            })
    }

    function listAddBatches(insid) {
        const getBatchList = api.getAllBatches + '/' + roleId + '/' + insid; //"?institutionName=" + insid + "&userId=" + userId + "&roleId=" + roleId;
        fetch(getBatchList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.error == true) {
                    Swal.fire(btchResult.message)
                    if (btchResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
                else {
                    setAddBatchList(btchResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to ftech the batches", error)
            })
    }

    function archiveBatch(row) {
        const instId = row.batchInstitution;
        const bchId = row.batchId;
        const archivebtch = api.ArchiveBatch + '/' + bchId + '/' + instId; //"/?insId=" + instId + "&batchId=" + bchId;
        fetch(archivebtch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((arcresponse) => arcresponse.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to archive batch", error)
            })
    }

    function nameExist(e) {
        e.preventDefault();
        if (!cbformRef.current.checkValidity()) {
            cbformRef.current.reportValidity();
        } else {
            // alert(newBatchName)
            const namePresent = api.DuplicateName + '/' + newBatchName + '/' + cbinstituteId; //"?batchName=" + newBatchName + "&institutionName=" + cbinstituteId;
            fetch(namePresent, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                }
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == true) {
                        Swal.fire(result.message)
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                    }
                    else (
                        addBatch()
                    )
                })
                .catch((error) => {
                    console.log("The name already exists", error)
                })
        }
    }

    function addBatch() {
        // alert(JSON.stringify(cbinstituteId))
        setIsLoading(true)
        setTimeout(() => {
            const formData = new FormData();
            formData.append("batchName", newBatchName);
            formData.append("batchInstitutionId", cbinstituteId);
            formData.append("batchCoachId", cbCoachId);
            formData.append("batchSportId", cbSportId);
            formData.append("batchProgramId", cbprogramId);
            const batchCreate = api.CreateBatch;
            fetch(batchCreate, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log("Failed to create new Batch.", error)
                })
        }, 1000);
    }


    function updateBatch(e) {
        e.preventDefault();
        if (!updtStudformRef.current.checkValidity()) {
            updtStudformRef.current.reportValidity();
        } else {
            const selectedStudents = checkboxRefs.current
                .filter(checkbox => checkbox.checked)
                .map(checkbox => checkbox.value);
            // console.log('list of students', selectedStudents);
            // console.log('batch id', batchId);
            // console.log('coach name', userId);
            // console.log('batch name', batchName);
            // console.log('programNameEdit', programId);
            // console.log('batch Status', batchStatus);
            // console.log('inst id', instituteId);
            // console.log('sport', sportName);

            // selectedStudents.forEach(element => {
            //     console.log(element)
            // });

            setIsLoading(true)
            setTimeout(() => {
                const formData = new FormData();
                selectedStudents.forEach(element => {
                    formData.append('batchId', batchId);
                    formData.append('coachNameEdit', batchCoachId);
                    formData.append('batchNameEdit', batchName);
                    formData.append('coach', batchCoachId);
                    formData.append('sport', sportId);
                    formData.append('programNameEdit', programId);
                    formData.append('batchInstitutionId', instituteId);
                    formData.append('studentChecked', 1);
                    formData.append('batchStatus', batchStatus);
                    formData.append('coreUserId', element);
                    formData.append('role', roleId);
                    formData.append('userId', batchCoachId);

                    const batchStud = api.updateBatchStudent;
                    fetch(batchStud, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData,
                    })
                        .then((uptdResponse) => uptdResponse.json())
                        .then((result) => {
                            if (result.error == false) {
                                setIsLoading(false);
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                setIsLoading(false);
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                })
                // window.location.reload();
                // studentList(instituteId)
            }, 1000)
        }
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="court-tab-content">
                                    <div className="card card-tableset">
                                        <div className="card-body">
                                            <div className="coache-head-blk">
                                                <div className="row align-items-center">
                                                    <div className="row col-md-12">
                                                        <div className="row col-md-12 court-sortby sortbyset">
                                                            <div className="col-md-2">
                                                                <span className="sortbytitle"><h6>Institute</h6></span>
                                                            </div>
                                                            <div className="col-md-4 col-sm-6 sorting-select">
                                                                {/* <Dropdown
                                                                    value={instituteId}
                                                                    onChange={(e) => listBatches(e.target.value)}
                                                                    options={instituteList}
                                                                    optionLabel="institutionName"
                                                                    optionValue="institutionId"
                                                                    placeholder="Select an Institute"
                                                                    className="select-bg w-100"
                                                                /> */}
                                                                <Select
                                                                    value={instituteList.find(ins => ins.institutionId === instituteId) ? {
                                                                        value: instituteId,
                                                                        label: instituteList.find(ins => ins.institutionId === instituteId).institutionName
                                                                    } : null}
                                                                    onChange={(e) => {
                                                                        setInstituteId(e.value);
                                                                        listBatches(e.value);
                                                                    }}
                                                                    options={instituteList.map(ins => ({
                                                                        value: ins.institutionId,
                                                                        label: ins.institutionName
                                                                    }))}>
                                                                </Select>
                                                            </div>
                                                            {(roleId == '1' || roleId == '5' || roleId == '6') && (
                                                                <>
                                                                    <div className="col-lg-2 col-sm-12 table-search-top">
                                                                        <Link
                                                                            className="btn btn-secondary"
                                                                            to="#"
                                                                            // style={{ padding: "10px 40px" }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#create-batch"
                                                                        >
                                                                            <span>
                                                                                <i className="fas fa-plus" />
                                                                            </span>
                                                                            Create Batch
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-4 col-sm-12 table-search-top">
                                                                        <Link
                                                                            className="btn btn-secondary"
                                                                            to="#"
                                                                            // style={{ padding: "10px 25px", marginLeft: "10rem" }}
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#add-students"
                                                                            onClick={addStuds}
                                                                        >
                                                                            <span>
                                                                                <i className="feather-user" />
                                                                            </span>
                                                                            Add Students to Batch
                                                                        </Link>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {showTable && (
                                                        <>
                                                            <div className="col-md-12">
                                                            </div>
                                                            <div className="col-md-12">
                                                            </div>
                                                            <div className="col-md-6">
                                                            </div>
                                                            <div className="col-md-6 mt-2">
                                                                <div className="dataTables_filter">
                                                                    <label>
                                                                        <input
                                                                            type="text"
                                                                            value={searchInput}
                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                            placeholder="Search"
                                                                            className="form-control"
                                                                        />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            {showTable && (
                                                <div className="tab-content">
                                                    <div
                                                        className="tab-pane fade show active"
                                                        id="nav-Recent"
                                                        role="tabpanel"
                                                        aria-labelledby="nav-Recent-tab"
                                                        tabIndex={0}
                                                    >
                                                        <div className="table-responsive table-datatble">
                                                            <DataTable
                                                                className="table datatable"
                                                                value={filteredData}
                                                                paginator
                                                                rows={10}
                                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                pageLinkSize={3}
                                                            >
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="slNo"
                                                                    body={slNoRender}
                                                                    header="Sl &nbsp; No"
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="batchName"
                                                                    header="Batch"
                                                                    body={batchRender}
                                                                    className="table-inset-btn"
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="institute"
                                                                    header="Institute"
                                                                    body={instituteRender}
                                                                    className="table-inset-btn"
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="institutionName"
                                                                    header="Coach"
                                                                    body={coachRender}
                                                                    className="table-inset-btn"
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="SportName"
                                                                    header="Sport"
                                                                    body={sportRender}
                                                                    className="table-inset-btn"
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="ProgramName"
                                                                    header="Program"
                                                                    body={programRender}
                                                                    className="table-inset-btn"
                                                                ></Column>
                                                                <Column
                                                                    className="text-link view-detail-pink"
                                                                    style={{ color: "#0F2A4E" }}
                                                                    body={detailsRender}
                                                                ></Column>
                                                                {(roleId == '1' || roleId == '5' || roleId == '6') && (
                                                                    <>
                                                                        <Column
                                                                            body={editDetails}
                                                                        ></Column>
                                                                    </>
                                                                )}
                                                                <Column
                                                                    body={statusRender}
                                                                ></Column>
                                                                {(roleId == '1' || roleId == '5' || roleId == '6') && (
                                                                    <>
                                                                        <Column
                                                                            body={archiveRow}
                                                                        ></Column>
                                                                    </>
                                                                )}
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Student List Modal */}
            <div
                className="modal custom-modal fade request-modal"
                id="student-list"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Student List
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            {/* Court Request */}
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card court-information">
                                        <div className="card dashboard-card court-information">
                                            <div className="card-header text-center">
                                                <h4 className="text-uppercase">{batchName}</h4>
                                            </div>
                                            <div className="booking-date row">
                                                {batchStudDetails.map((stud, index) => (
                                                    <div key={index} className="col-12 col-sm-4 col-md-3">
                                                        <div className="time-slot">
                                                            <h6 className="text-uppercase">{stud.studentname}</h6>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* /Court Request */}
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link
                                    to="#"
                                    data-bs-dismiss="modal"
                                    className="btn cancel-table-btn"
                                >
                                    Cancel
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Student List Modal */}

            {/* Edit Batch Modal */}
            <div
                className="modal custom-modal fade request-modal"
                id="edit-batch"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Edit Batch
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <form ref={updtStudformRef}>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <div className="mb-10">
                                                        <span className="sortbytitle"><h6>Institute</h6></span>
                                                        <Select
                                                            value={instituteList.find(ins => ins.institutionId === instituteId) ? {
                                                                value: instituteId,
                                                                label: instituteList.find(ins => ins.institutionId === instituteId).institutionName
                                                            } : null}
                                                            required
                                                            onChange={(e) => {
                                                                setInstituteId(e.value);
                                                            }}
                                                            options={instituteList.map(ins => ({
                                                                value: ins.institutionId,
                                                                label: ins.institutionName
                                                            }))}>
                                                        </Select>
                                                    </div>
                                                </div>
                                                {(roleId == 1) && (
                                                    <>
                                                        <div className="col-lg-4">
                                                            <div className="mb-10">
                                                                <span className="sortbytitle"><h6>Coach</h6></span>
                                                                <Select
                                                                    value={coachDetails.find(coch => coch.internalUserId === batchCoachId) ? {
                                                                        value: batchCoachId,
                                                                        label: coachDetails.find(coch => coch.internalUserId === batchCoachId).coachName
                                                                    } : null}
                                                                    required
                                                                    onChange={(e) => setBatchCoachId(e.value)}
                                                                    options={coachDetails.map(coch => ({
                                                                        value: coch.internalUserId,
                                                                        label: coch.coachName
                                                                    }))}>
                                                                </Select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-10">
                                                                <span className="sortbytitle"><h6>Sport</h6></span>
                                                                <Select
                                                                    value={sprtInsDetails.find(sprt => sprt.sportId === sportId) ? {
                                                                        value: sportId,
                                                                        label: sprtInsDetails.find(sprt => sprt.sportId === sportId).sportName
                                                                    } : null}
                                                                    required
                                                                    onChange={(e) => setSportId(e.value)}
                                                                    options={sprtInsDetails.map(sprt => ({
                                                                        value: sprt.sportId,
                                                                        label: sprt.sportName
                                                                    }))}>
                                                                </Select>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="col-lg-4">
                                                    <div className="mb-10">
                                                        <span className="sortbytitle"><h6>Program</h6></span>
                                                        <Select
                                                            value={programList.find(prog => prog.programId === programId) ? {
                                                                value: programId,
                                                                label: programList.find(prog => prog.programId === programId).programName
                                                            } : null}
                                                            onChange={(e) => setProgramId(e.value)}
                                                            required
                                                            options={programList.map(prog => ({
                                                                value: prog.programId,
                                                                label: prog.programName
                                                            }))}>
                                                        </Select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="mb-10">
                                                        <span className="sortbytitle"><h6>Batch</h6></span>
                                                        <input type="text" className="form-control" required value={batchName} onChange={(e) => setBatchName(e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Profile Availability */}
                                            <div className="row" style={{ padding: "24px" }}>
                                                <div className="col-lg-12">
                                                    <div className="card court-information profile-availability">
                                                        <div className="row accordion setting-accordion">
                                                            <div className="row gx-2">
                                                                <div className="col-md-12">
                                                                    <div className="col-md-6" />
                                                                    <div className="col-md-6">
                                                                        <div className="dataTables_filter">
                                                                            <label>
                                                                                <input
                                                                                    type="text"
                                                                                    value={searchQuery}
                                                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                                                    placeholder="Search Students"
                                                                                    className="form-control"
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="token-slot mt-2">
                                                                        {filteredStudents.map((stud, index) => (
                                                                            <div key={index} className="form-check-inline visits court-information col-12 col-sm-4 col-md-2">
                                                                                <label className="visit-btns">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        defaultValue={stud.coreUserId}
                                                                                        defaultChecked={!!stud.studentStatus} // ? Check if studentStatus is not empty
                                                                                        ref={el => checkboxRefs.current[index] = el}
                                                                                    />
                                                                                    <span
                                                                                        className="visit-rsn"
                                                                                        data-bs-toggle="tooltip"
                                                                                        title={stud.coreUser}
                                                                                    >
                                                                                        {stud.coreUser}
                                                                                    </span>
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="save-changes text-sm-end">
                                                            <Link
                                                                to="#"
                                                                className="btn btn-secondary save-profile"
                                                                onClick={updateBatch}
                                                                aria-label="Close"
                                                            >
                                                                Update
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /Profile Availability */}
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Edit Batch Modal */}

            {/* Create Batch Modal */}
            <div
                className="modal custom-modal fade payment-modal"
                id="create-batch"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Create Batch
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <form ref={cbformRef}>
                                <div className="col-lg-12">
                                    <div className="input-space">
                                        <label className="form-label">Institute</label>
                                        <Select
                                            required
                                            value={instituteList.find(ins => ins.institutionId === cbinstituteId) ? {
                                                value: cbinstituteId,
                                                label: instituteList.find(ins => ins.institutionId === cbinstituteId).institutionName
                                            } : null}
                                            onChange={(e) => {
                                                setCbInstituteId(e.value);
                                                coachList(e.value);
                                            }}
                                            placeholder="Select Institute"
                                            options={instituteList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                {(roleId == 1 || roleId == 5) && (
                                    <>
                                        <div className="col-lg-12">
                                            <div className="input-space">
                                                <span className="sortbytitle">Coach</span>
                                                <Select
                                                    value={coachDetails.find(coch => coch.internalUserId === cbCoachId) ? {
                                                        value: cbCoachId,
                                                        label: coachDetails.find(coch => coch.internalUserId === cbCoachId).coachName
                                                    } : null}
                                                    onChange={(e) => {
                                                        setCbCoachId(e.value);
                                                        sportsList(e.value, cbinstituteId)
                                                    }}
                                                    required
                                                    options={coachDetails.map(coch => ({
                                                        value: coch.internalUserId,
                                                        label: coch.coachName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="input-space">
                                                <span className="sortbytitle">Sport</span>
                                                <Select
                                                    value={sprtInsDetails.find(sprt => sprt.sportId === cbSportId) ? {
                                                        value: cbSportId,
                                                        label: sprtInsDetails.find(sprt => sprt.sportId === cbSportId).sportName
                                                    } : null}
                                                    onChange={(e) => setCbSportId(e.value)}
                                                    required
                                                    options={sprtInsDetails.map(sprt => ({
                                                        value: sprt.sportId,
                                                        label: sprt.sportName
                                                    }))}>
                                                </Select>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className="col-lg-12">
                                    <div className="input-space">
                                        <label className="form-label">Program</label>
                                        <Select
                                            required
                                            value={programList.find(prog => prog.programId === cbprogramId) ? {
                                                value: cbprogramId,
                                                label: programList.find(prog => prog.programId === cbprogramId).programName
                                            } : null}
                                            onChange={(e) => {
                                                setCbProgramId(e.value);
                                            }}
                                            placeholder="Select Program"
                                            options={programList.map(prog => ({
                                                value: prog.programId,
                                                label: prog.programName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="input-space">
                                        <label className="form-label">Batch </label>
                                        <input
                                            id="batchName"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                            value={newBatchName}
                                            required
                                            onChange={(e) => {
                                                setNewBatchName(e.target.value)
                                                // nameExist(e.target.value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link to="#" className="btn btn-primary close" onClick={nameExist} aria-label="Close">
                                    Submit
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Create Batch Modal */}

            {/* Add Students to Batch */}
            <div
                className="modal custom-modal fade request-modal"
                id="add-students"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    <i className="fas fa-plus" />
                                    Add Students to Batch
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card dashboard-card">
                                            <form ref={adStudformRef}>
                                                <div className="row col-md-12">
                                                    <div className="col-md-5">
                                                        <div className="mb-10">
                                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                                            <Select
                                                                value={instituteList.find(ins => ins.institutionId === addInstituteId) ? {
                                                                    value: addInstituteId,
                                                                    label: instituteList.find(ins => ins.institutionId === addInstituteId).institutionName
                                                                } : null}
                                                                required
                                                                onChange={(e) => {
                                                                    setAddInstituteId(e.value);
                                                                    coachList(e.value);
                                                                    getClass(e.value);
                                                                    listAddBatches(e.value);
                                                                }}
                                                                options={instituteList.map(ins => ({
                                                                    value: ins.institutionId,
                                                                    label: ins.institutionName
                                                                }))}>
                                                            </Select>
                                                        </div>
                                                        <div className="mb-10">
                                                            <label className="sortbytitle"><h6>Class</h6></label>
                                                            <Select
                                                                value={classList.find(cls => cls.classId === classId) ? {
                                                                    value: classId,
                                                                    label: classList.find(cls => cls.classId === classId).className
                                                                } : null}
                                                                required
                                                                onChange={(e) => {
                                                                    setClassId(e.value);
                                                                    getSection(e.value);
                                                                }}
                                                                options={classList.map(cls => ({
                                                                    value: cls.classId,
                                                                    label: cls.className
                                                                }))}>
                                                            </Select>
                                                        </div>
                                                        <div className="mb-10">
                                                            <label className="sortbytitle"><h6>Section</h6></label>
                                                            <Select
                                                                value={sectionList.find(sec => sec.sectionId === sectionId) ? {
                                                                    value: sectionId,
                                                                    label: sectionList.find(sec => sec.sectionId === sectionId).sectionName
                                                                } : null}
                                                                required
                                                                onChange={(e) => {
                                                                    setSectionId(e.value);
                                                                    studentsList(e.value);
                                                                }}
                                                                options={sectionList.map(sec => ({
                                                                    value: sec.sectionId,
                                                                    label: sec.sectionName
                                                                }))}>
                                                            </Select>
                                                        </div>
                                                        {(roleId == 1 || roleId == 5) && (
                                                            <>
                                                                <div className="mb-10">
                                                                    <label className="sortbytitle"><h6>Coach</h6></label>
                                                                    <Select
                                                                        value={coachDetails.find(coch => coch.internalUserId === addCoachId) ? {
                                                                            value: addCoachId,
                                                                            label: coachDetails.find(coch => coch.internalUserId === addCoachId).coachName
                                                                        } : null}
                                                                        required
                                                                        onChange={(e) => setAddCoachId(e.value)}
                                                                        placeholder="Please Wait.."
                                                                        options={coachDetails.map(coch => ({
                                                                            value: coch.internalUserId,
                                                                            label: coch.coachName
                                                                        }))}>
                                                                    </Select>
                                                                </div>
                                                            </>
                                                        )}
                                                        <div className="mb-10">
                                                            <span className="sortbytitle"><h6>Program</h6></span>
                                                            <Select
                                                                value={programList.find(prog => prog.programId === addProgramId) ? {
                                                                    value: addProgramId,
                                                                    label: programList.find(prog => prog.programId === addProgramId).programName
                                                                } : null}
                                                                required
                                                                onChange={(e) => setAddProgramId(e.value)}
                                                                placeholder="Select Program"
                                                                options={programList.map(prog => ({
                                                                    value: prog.programId,
                                                                    label: prog.programName
                                                                }))}>
                                                            </Select>
                                                        </div>
                                                        <div className="mb-10">
                                                            <span className="sortbytitle"><h6>Batch</h6></span>
                                                            <Select
                                                                value={addBatchList.find(btch => btch.batchId === addBatchId) ? {
                                                                    value: addBatchId,
                                                                    label: addBatchList.find(btch => btch.batchId === addBatchId).batchName
                                                                } : null}
                                                                required
                                                                onChange={(e) => setAddBatchId(e.value)}
                                                                placeholder="Please Wait.."
                                                                options={addBatchList.map(btch => ({
                                                                    value: btch.batchId,
                                                                    label: btch.batchName
                                                                }))}>
                                                            </Select>
                                                        </div>
                                                    </div>
                                                    {showList && (
                                                        <>
                                                            <div className="col-md-7">
                                                                <div className="col-md-6">
                                                                    <div className="dataTables_filter">
                                                                        <label>
                                                                            <input
                                                                                type="text"
                                                                                value={searchAddQuery}
                                                                                onChange={(e) => setSearchAddQuery(e.target.value)}
                                                                                placeholder="Search Students"
                                                                                className="form-control"
                                                                            />
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="court-information profile-availability">
                                                                    <div className="row accordion setting-accordion">
                                                                        <div className="token-slot mt-2" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                                                            {filteredAddStudents.map((stud, index) => (
                                                                                <div key={index} className="form-check-inline visits court-information col-12 col-sm-2 col-md-3">
                                                                                    <label className="visit-btns">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            defaultValue={stud.coreUserId}
                                                                                            ref={el => addcheckboxRefs.current[index] = el}
                                                                                        />
                                                                                        <span
                                                                                            className="visit-rsn"
                                                                                            data-bs-toggle="tooltip"
                                                                                            title={stud.coreUserFirstName + ' ' + stud.coreUserLastName}
                                                                                        >
                                                                                            {stud.coreUserFirstName + ' ' + stud.coreUserLastName}
                                                                                        </span>
                                                                                    </label>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <button type="submit" className="btn btn-primary " onClick={addStudBatch} aria-label="Close">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* /Add Students to Batch */}

        </>
    );
};

export default Batches;